module.exports = __webpack_public_path__ + "static/media/diandiandian.b3a0048f.png";